import styled from 'styled-components';
import { device } from '../../ui-components/breakpoints';
import { playGrey5 } from '../../ui-components/design-tokens';
import { ClearFix } from '../../ui-components/utils.styles';

export const StyledHeader = styled.header`
    position: relative;
    background-color: ${playGrey5};
    z-index: 300;
    min-width: 100%;
`;

export const GlobalHeader = styled.div`
    ${ClearFix};
    padding-top: 5px;
    margin: 0 auto;
    max-width: 100%;

    @media print {
        display: none !important;
    }

    @media ${device.GteSmall} {
        height: 45px;
        padding-top: 12px;
    }

    @media ${device.GteMedium} {
        margin-bottom: 0;
        padding-top: 20px;
        height: 55px;
    }
`;
